import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import DialogActions from '@mui/material/DialogActions';

export const card_variants = {
    calendar: {
        backgroundColor: '#F7F9FA',
        border: '1px solid #F2F2F7'
    },
    default: {
        backgroundColor: '#FFFFFF',
        border: '1px solid #E5E7EB'
    },
    lightYellow: {
        backgroundColor: '#FBF5E2'
    },
    redAlert: {
        color: '#D32F2F'
    }
};

// Styled DialogActions that accepts a `variant` prop
export const VariantElement = styled(Box, {
    shouldForwardProp: (prop) => prop !== 'variant'
})(({ variant = 'default' }) => {
    return card_variants[variant] || card_variants.default;
});